import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/categories';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  date: string;
  readTime: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  image,
  date,
  readTime,
}: ArticleCardProps) {
  const cat = categoryMap[category];

  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {cat && (
          <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-800">
            {cat.name}
          </span>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span>{date}</span>
          <span>{readTime}</span>
        </div>
      </div>
    </Link>
  );
}